// extracted by mini-css-extract-plugin
export default {"item":"ProductItem_item__DrQDn","price":"ProductItem_price__VJE-i","actions":"ProductItem_actions__8Gp74"};